import { Controller } from "@hotwired/stimulus"

// Resets a modal's form content to its original state whenever the modal is closed.
// Flowbite sets aria-hidden="true" on the modal element when it hides — we watch
// for that attribute change and restore the saved inner HTML.
//
// Usage:
//   <div id="my-modal" data-controller="modal-reset" ...>
//     <div data-modal-reset-target="content"> ... form ... </div>
//   </div>
export default class extends Controller {
  static targets = ["content"]

  connect() {
    this.originalHTML = this.contentTarget.innerHTML

    this.observer = new MutationObserver(() => {
      if (this.element.getAttribute("aria-hidden") === "true") {
        this.contentTarget.innerHTML = this.originalHTML
        if (window.turnstile) {
          this.element.querySelectorAll(".cf-turnstile").forEach(el => {
            window.turnstile.render(el)
          })
        }
      }
    })

    this.observer.observe(this.element, { attributes: true, attributeFilter: ["aria-hidden"] })
  }

  disconnect() {
    this.observer?.disconnect()
  }
}
